/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IQService} from 'angular';
import AuthServiceRS from '../../../../authentication/service/AuthServiceRS.rest';
import TSAnlaufstelle from '../../../../models/TSAnlaufstelle';
import AnlaufstelleRS from '../../../service/AnlaufstelleRS.rest';
import RoleUtilService from '../../../service/RoleUtilService';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;

declare let require: any;
declare let angular: any;
require('./dv-anlaufstelle-typeahead.scss');

export class DVAnlaufstelleTypeaheadComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        selectedAnlaufstelle: '=',
        inputName: '@?',
        inputPlaceholder: '@?',
        inputDisabled: '<?',
        label: '@',
        clazz: '@',
        ngRequired: '<',
    };
    template = require('./dv-anlaufstelle-typeahead.html');
    controller = DvAnlaufstelleTypeaheadController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvAnlaufstelleTypeaheadController {

    inputDisabled: boolean;
    selectedAnlaufstelle: TSAnlaufstelle;
    ngRequired: boolean;
    valueRequired: boolean = true; // default required

    static $inject = ['$log', '$q', 'AnlaufstelleRS', 'AuthServiceRS'];

    constructor(private $log: ILogService, private $q: IQService, private anlaufstelleRS: AnlaufstelleRS,
                private authServiceRS: AuthServiceRS, private roleUtilService: RoleUtilService) {
    }

    $onInit() {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
        if (this.inputDisabled === undefined) {
            this.inputDisabled = false;
        }

    }

    private loadSuggestElements(searchString: string): IPromise<Array<TSAnlaufstelle>> {
        return this.anlaufstelleRS.readAnlaufstellenSuggestion(searchString).then((response) => {
            return response;

        })
    }

    // private loadAvailableAnlaufstellen(): Array<TSAnlaufstelle> {
    // 	let benutzer: TSUser | undefined = this.authServiceRS.getPrincipal();
    // 	if (benutzer && benutzer.id) {
    // 		if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
    // 			//admin und fs-sachbearbeiter hat alle zur auswahl
    // 			this.anlaufstelleRS.getAllAnlaufstellen().then((response: Array<TSAnlaufstelle>) => {
    // 				return response;
    // 			});
    // 		}
    // 	}
    // 	return [];
    // }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-typeahead/dv-anlaufstelle-typeahead/dv-anlaufstelle-typeahead.ts